<template>
  <div class="shop-container">
    <div class="nav">
      <router-link to="/">首页</router-link>
      <span>></span>
      <a href="javascript:;">全部结果</a>
      <template v-if="$route.query.name">
        <span>></span>
        <span v-if="$route.query.id">分类:</span>
        <span>{{$route.query.name}}</span>
      </template>
    </div>
    <div class="bgw nodata" v-if="noDataIsShow">
      没有找到与“
      <span class="search-name">{{$route.query.name}}</span> ”相关的商品
    </div>
    <div class="container bgw" v-show="showFilter">
      <div class="filter-box">
        <div class="filter-list-wrap" v-if="catList.length>0">
          <div class="filter-list-head">分类:</div>
          <div class="filter-list">
            <!-- <div class="filter-item active">全部</div> -->
            <div
              class="filter-item"
              v-for="(item,index) in filterClassComputed(catList,'class')"
              :key="index"
              @click="selectCat(item.goods_cat_id)"
              :class="selectedCatId==item.goods_cat_id?'active':''"
            >{{item.name}}</div>
          </div>
          <div class="more" @click="showMoreClass=!showMoreClass" v-if="catList.length>6">
            {{showMoreClass?'收起':'更多'}}
            <i
              class="icon iconfont iconxjt"
              :class="{'top':showMoreClass}"
            ></i>
          </div>
        </div>
        <div class="filter-list-wrap" v-if="brandList.length>0">
          <div class="filter-list-head">品牌:</div>
          <div class="filter-list">
            <!-- <div class="filter-item active">全部</div> -->
            <div
              class="filter-item"
              v-for="(item,index) in filterClassComputed(brandList,'brand')"
              :key="index"
              @click="selectBrand(item.brand_id)"
              :class="selectedBrandId==item.brand_id?'active':''"
            >{{item.name}}</div>
          </div>
          <div class="more" v-if="brandList.length>6" @click="showMoreBrand=!showMoreBrand">
            {{showMoreBrand?'收起':'更多'}}
            <i
              class="icon iconfont iconxjt"
              :class="{'top':showMoreBrand}"
            ></i>
          </div>
        </div>
        <div class="sort-box">
          <span class="sort-title">排序:</span>
          <ul class="filter-nav">
            <li :class="{'active':searchOptions.order.key=='sort'}">
              <a href="javascript:;" @click="comprehensive">综合</a>
            </li>
            <li :class="{'active':searchOptions.order.key=='price'}">
              <a href="javascript:;" @click="priceSort">
                价格
                <i
                  class="icon iconfont"
                  :class="searchOptions.order.key=='price'&&searchOptions.order.sort=='asc'?'iconpriceup':'iconpricedown'"
                ></i>
              </a>
            </li>
            <li :class="{'active':searchOptions.order.key=='buy_count'}">
              <a href="javascript:;" @click="salesVolume">
                销量
                <i
                  class="icon iconfont"
                  :class="searchOptions.order.key=='buy_count'&&searchOptions.order.sort=='asc'?'iconpriceup':'iconpricedown'"
                ></i>
              </a>
            </li>
          </ul>
        </div>

        <div class="filter-checkbox" v-if="labelList.length>0">
          <span>筛选:</span>
          <el-checkbox-group v-model="checkList">
            <el-checkbox :label="item.id" v-for="(item,i) in labelList" :key="i">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div v-loading="loadingShow">
      <ProductRowFive :list="goodsList"></ProductRowFive>
    </div>
    <template v-if="goodsList.length>0">
      <Pagination
        :totalPage="totalPage"
        :limit="searchOptions.limit"
        @changePage="handleCurrentChange"
      ></Pagination>
    </template>
  </div>
</template>

<script>
import ProductRowFive from "@/components/layout/ProductRowFive.vue";
import Pagination from "@/components/common/Pagination.vue";
import { deepCopy } from "@/utils";
export default {
  name: "SearchResult",
  components: { ProductRowFive, Pagination },
  props: {},
  data() {
    return {
      showFilter: true,
      showMoreClass: false,
      showMoreBrand: false,
      checkList: [],
      catList: [], //分类
      brandList: [], //品牌
      labelList: [], //筛选标签
      goodsList: [],
      totalPage: 0,
      searchOptions: {
        where: {},
        limit: 15,
        page: 1,
        order: {
          key: "sort",
          sort: "asc" //默认综合排序
        }
      },
      noDataIsShow: false,
      loadingShow: false,
      firstLoad: true, //是否初次加载
      selectedCatId: "", //选择的分类ID
      selectedBrandId: "", //选择的品牌ID
      selectedlabelId: "" //选择的筛选ID
    };
  },
  watch: {
    $route(to, from) {
      if (from.name == "detail") return;
      if (this.$route.name == "search") {
        let query = this.$route.query;
        this.initData(query);
      }
    }
  },

  computed: {
    filterClassComputed() {
      return (list, type) => {
        if (list.length < 7) {
          return list;
        }
        if (type == "class") {
          if (this.showMoreClass) {
            return list;
          }
        }
        if (type == "brand") {
          if (this.showMoreBrand) {
            return list;
          }
        }
        return list.slice(0, 6);
      };
    }
  },
  methods: {
    initData(query) {
      this.firstLoad = true;
      this.selectedCatId = "";
      this.selectedBrandId = "";
      this.selectedlabelId = "";
      let sd = this.searchOptions;
      this.searchOptions = Object.assign(sd, { where: {} });
      this.handleParamsData(query);
    },
    //搜索分类
    selectCat(id) {
      let data = {
        page: 1,
        where: {
          cat_id: id
        }
      };
      this.selectedCatId = id;
      this.setSearchOptions(data, true);
      this.getGoodsList();
    },
    //搜索品牌
    selectBrand(id) {
      let data = {
        page: 1,
        where: {
          brand_id: id
        }
      };
      this.selectedBrandId = id;
      this.setSearchOptions(data, true);
      this.getGoodsList();
    },
    //筛选条件参数处理
    conditions() {
      let data = this.searchOptions;
      var newData = {};
      newData = deepCopy(newData, data);
      //把data里的where换成json
      if (data.where) {
        newData.where = JSON.stringify(data.where);
      }
      //把排序换成字符串
      if (data.order) {
        var sort = data.order.key + " " + data.order.sort;
        if (data.order.key != "sort") {
          sort = sort + ",sort asc"; //如果不是综合排序，增加上第二个排序优先级排序
        }
        newData.order = sort;
      } else {
        newData.order = "sort asc";
      }
      return newData;
    },
    handleParamsData(query) {
      let where = {};
      if (query.key) {
        where = { search_name: query.key };
      }
      if (query.id) {
        where = {
          cat_id: query.id
        };
      }
      if (query.type) {
        if (query.type == "hot") {
          where = {
            hot: true
          };
        }
        if (query.type == "recommend") {
          where = {
            recommend: true
          };
        }
      }
      this.setSearchOptions({ where: where });
      this.getGoodsList();
    },
    //点击综合排序
    comprehensive: function() {
      this.setSearchOptions(
        {
          order: {
            key: "sort",
            sort: "asc"
          },
          page: 1
        },
        true
      );
      this.getGoodsList();
    },
    //销量排序
    salesVolume: function() {
      let sort = "asc";
      if (this.searchOptions.order.key == "buy_count") {
        if (this.searchOptions.order.sort == "desc") {
          sort = "asc";
        } else {
          sort = "desc";
        }
      }
      this.setSearchOptions(
        {
          order: {
            key: "buy_count",
            sort: sort
          },
          page: 1
        },
        true
      );
      this.getGoodsList();
    },
    //价格排序
    priceSort: function() {
      let sort = "asc";
      if (this.searchOptions.order.key == "price") {
        if (this.searchOptions.order.sort == "desc") {
          sort = "asc";
        } else {
          sort = "desc";
        }
      }
      this.setSearchOptions(
        {
          order: {
            key: "price",
            sort: sort
          },
          page: 1
        },
        true
      );
      this.getGoodsList();
    },

    //获取商品列表
    getGoodsList() {
      let obj = this.conditions();
      this.loadingShow = true;
      this.$api.goodsList(obj).then(res => {
        if (res.status) {
          this.totalPage = res.data.total_page;
          this.goodsList = res.data.list;
          this.showFilter = this.goodsList.length > 0 ? true : false;
          let filter = res.data.filter;
          if (this.firstLoad) {
            this.firstLoad = false;
            this.catList = filter.goods_cat ? filter.goods_cat : [];
            this.brandList = filter.brand_ids ? filter.brand_ids : [];
            this.labelList = filter.label_ids ? filter.label_ids : [];
          }
          if (res.data.list.length == 0) {
            this.noDataIsShow = true;
          } else {
            this.noDataIsShow = false;
          }
          this.loadingShow = false;
        }
      });
    },
    //设置筛选条件
    setSearchOptions: function(searchData, clear = false) {
      var sd = this.searchOptions;
      this.searchOptions = deepCopy(sd, searchData);
      if (clear) {
        this.goodsList = [];
      }
    },
    //分页
    handleCurrentChange(val) {
      this.setSearchOptions({
        page: val
      });
      this.getGoodsList();
    }
  },
  created() {
    let query = this.$route.query;
    this.handleParamsData(query);
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.shop-container {
  .nav {
    @include line-height(40px);
    font-size: 12px;
    span {
      padding: 0 3px;
      font-size: #757575;
    }
    a:hover {
      color: #000;
    }
  }
  .nodata {
    height: 40px;
    line-height: 40px;
    margin-bottom: 10px;
    padding-left: 14px;
    font-weight: bold;
    background: #fffdee;
    border: 1px solid #edd28b;
    .search-name {
      color: $theme-color;
    }
  }
  .container {
    background: #fff;
    padding: 4px 18px;
    margin-bottom: 20px;
    .filter-box {
      margin: 0 auto;
      font-size: 14px;
      .filter-list-wrap {
        position: relative;
        padding-left: 72px;
        transition: height 0.25s linear;
        border-bottom: 1px dashed $border;
        &.open {
          .filter-list {
            height: 120px;
          }
        }
        .filter-list-head {
          width: 72px;
          position: absolute;
          left: 0;
          top: 14px;
          color: #b0b0b0;
        }
        .filter-list {
          display: flex;
          flex-flow: row wrap;
          .filter-item {
            width: 150px;
            height: 20px;
            line-height: 20px;
            padding: 12px 0;
            cursor: pointer;
            &.active {
              color: $theme-color;
            }
          }
        }
        .more {
          position: absolute;
          right: 0;
          top: 8px;
          height: 24px;
          line-height: 24px;
          color: #757575;
          cursor: pointer;
          user-select: none;
          &:hover {
            color: $theme-color;
          }
          .icon {
            display: inline-block;
            transition: all 0.2s;
            &.top {
              transform: rotate(180deg);
            }
          }
        }
      }
    }
  }
  .sort-box {
    position: relative;
    padding-left: 72px;
    .sort-title {
      position: absolute;
      top: 0;
      left: 0;
      height: 45px;
      line-height: 45px;
      color: #b0b0b0;
    }
  }
  .filter-nav {
    height: 45px;
    display: flex;
    align-items: center;
    li {
      padding: 0 30px;
      font-size: 14px;
      border-right: 1px solid $border;
      &:last-of-type {
        border: none;
      }
      &:hover {
        color: $theme-color;
        .icon {
          color: $theme-color;
        }
      }
      a {
        display: block;
      }
      &.active {
        color: $theme-color;
        .icon {
          color: $theme-color;
        }
      }
      &:first-of-type {
        padding-left: 0;
        padding-right: 30px;
      }
      .icon {
        color: #333;
        font-size: 14px;
      }
    }
    .sort-title {
      margin-right: 40px;
    }
  }
  .filter-checkbox {
    height: 45px;
    line-height: 45px;
    position: relative;
    padding-left: 72px;
    border-top: 1px dashed $border;
    span {
      position: absolute;
      left: 0;
      top: 0;
      color: #b0b0b0;
    }
  }
}
</style>